export default __webpack_public_path__ + "static/MediaContentOne-1df18b579b06966dee71e3cddb455b47.webp";